import { ExcelColumn } from "api/generated/lumen";
import useFeature from "hooks/useFeature";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseFailureTypesListColumnTitles {
  columns: ExcelColumn[];
}

const useFailureTypesListColumnTitles = (): UseFailureTypesListColumnTitles => {
  const { t } = useTranslation();

  const {
    isEnabled: isFailureTypeSpecialCaseEnabled,
    label: failureTypeSpecialCaseLabel,
  } = useFeature("failureSpecialCase");

  const columns = useMemo(
    () => [
      {
        displayName: t("failureType.name"),
        propertyName: "name",
      },
      {
        displayName: t("failureType.tasks"),
        propertyName: "tasks",
      },
      ...(isFailureTypeSpecialCaseEnabled && failureTypeSpecialCaseLabel
        ? [
            {
              displayName: failureTypeSpecialCaseLabel,
              propertyName: "specialCase",
            },
          ]
        : []),
    ],
    [failureTypeSpecialCaseLabel, isFailureTypeSpecialCaseEnabled, t]
  );

  return {
    columns,
  };
};

export default useFailureTypesListColumnTitles;
